
class CalculatorHistory {
  constructor() {
    this.history = [];
  }

  saveCalculatorHistory(currentEntry) {
    const historyCopy = this.history.slice();
    historyCopy.unshift(currentEntry);
    this.history = historyCopy;
    if (this.history.length > 3) {
      this.history.splice(3);
    }
  }

  displayCalculatorHistory(historyData){
    const historyHTML = this.history.map(historyData).join('')
    setTimeout(function () {
      $('#cal-history').html(historyHTML);
    }, 1500);
  }
 
}
/* Start Calculator */
let isfutureCalculator = "future-value";

const calculatorConstants = {
  "future-value": {
    totalInvestment: {
      // in rupees
      default: 25000,
      min: 500,
      max: 5000000,
    },
    returnRate: {
      // in %
      default: 12,
      min: 0,
      max: 100,
    },
    timePeriod: {
      // in per yrs
      default: 10,
      min: 1,
      max: 365,
    },
    numberofyear: {
      // in yrs
      default: 10,
      min: 1,
      max: 100,
    },
  },
};

let totalInvestment = calculatorConstants[isfutureCalculator].totalInvestment.default;
let returnRate = calculatorConstants[isfutureCalculator].returnRate.default;
let timePeriod = calculatorConstants[isfutureCalculator].timePeriod.default;
let numberofyear = calculatorConstants[isfutureCalculator].numberofyear.default;

const totalInvestmentHTML = document.getElementById('total-investment');
const investedAmountHTML = document.getElementById('invested-amount');
const estAmountHTML = document.getElementById('est-amount');    
const investmentTitle =  document.getElementById('investment-slider-title');


function updatefutureTextValues() {
  const totalReturnValue = calculatefutureReturn();
  totalInvestmentHTML.innerHTML = getOuputFormat(totalReturnValue)
  investedAmountHTML.innerHTML = getOuputFormat(totalInvestment)
  estAmountHTML.innerHTML = getOuputFormat(totalReturnValue - totalInvestment)
  barChart(Number(totalInvestment), Number(totalReturnValue - totalInvestment));
}


function barChart(investment, returns) {
  const total = (investment + returns) / 100;
  const investmentPercent = investment / total;
  const returnsPercent = returns / total;
  updateBar("investment", minMaxBarPercent(investmentPercent));
  updateBar("returns", minMaxBarPercent(returnsPercent));
}

function minMaxBarPercent(value) {
  if (value < 1) {
    return 1;
  } else if (value > 99) {
    return 99;
  } else {
    return value;
  }
}

function updateBar(classInfo, width) {
  const elements = document.querySelector(`.distribution-bar .${classInfo}`);
  elements.style.width = `${width * 100}%`;
}

function forceValueRanges(input, type, forceMin = false) {
  const value = Number(removeCharsFromString(input.val()));
  const allowedMax = calculatorConstants[isfutureCalculator][type].max;
  const allowedMin = calculatorConstants[isfutureCalculator][type].min;
  if (value > allowedMax) {
    input.val(getOuputFormat(allowedMax, input.data("type")));
  }

  function forceMinValues() {
    if (value < allowedMin && value) {
      input.val(getOuputFormat(allowedMin, input.data("type")));
    }
  }

  if (forceMin) {
    forceMinValues();
  }
}

/* Inputs */

$("input#investment").on("input", function (event) {
  forceValueRanges($("input#investment"), "totalInvestment");
  totalInvestment = Number(removeCharsFromString(event.target.value));
});

$("input#return-rate-slider").on("input", function (event) {
  returnRate = Number(event.target.value);
  $("input#return-rate-input").val(
    getOuputFormat(returnRate, "percent")
  );
});

$("input#return-rate-input").on("input", function (event) {
  forceValueRanges($("input#return-rate-input"), "returnRate", true);
  returnRate = Number(removeCharsFromString(event.target.value));
  $("input#return-rate-slider").val(returnRate).change();
});

$("input#period-input-slider").on("input", function (event) {
  timePeriod = Number(event.target.value);
  $("input#period-input").val(getOuputFormat(timePeriod, "none"));
});

$("input#period-input").on("input", function (event) {
  forceValueRanges($("input#period-input"), "timePeriod", true);
  timePeriod = Number(removeCharsFromString(event.target.value));
  $("input#period-input-slider").val(timePeriod).change();
});

$("input#numberofyear-input-slider").on("input", function (event) {
  numberofyear = Number(event.target.value);
  $("input#numberofyear-input").val(getOuputFormat(numberofyear, "years"));
});

$("input#numberofyear-input").on("input", function (event) {
  forceValueRanges($("input#numberofyear-input"), "numberofyear", true);
  numberofyear = Number(removeCharsFromString(event.target.value));
  $("input#numberofyear-input-slider").val(numberofyear).change();
});


$("input[type=number]").on("keydown", function (e) {
  let invalidChars = ["-", "+", "e"];
  if (invalidChars.includes(e.key)) {
    e.preventDefault();
  }
});


function calculatefutureReturn() {
  // A = P (1 + r/n) ^ nt   .. n=1 so can ignore it
  const i = Number(returnRate) * 0.01; //return %
  const PV = Number(totalInvestment); // Invested amount
  const n = Number(timePeriod);
   const t = Number(numberofyear);

  return Math.round(PV * ((1 + i/n) ** t*n));
}


function updateTextValues() {
  return updatefutureTextValues();
}

function init() {
  updateTextValues();
}

$(".cal-slider .form-group input").on("input", function () {
  updateTextValues();
});

init();

$(".calc-slide .input").on("input", function () {
  setInput($(this));
});

/* set history data to input fields  */
function setHistoryValuesToInputFields(historyOBj, key) {
  $("input#investment").val(
    getOuputFormat(historyOBj[key].investment, "rupee")
  ).trigger('input');
  $("input#return-rate-input").val(
    getOuputFormat(historyOBj[key].interest, "percent")
  ).trigger('input');
  $("input#period-input").val(
    getOuputFormat(historyOBj[key].periods, "none")
  ).trigger('input');
  $("input#numberofyear-input").val(
    getOuputFormat(historyOBj[key].time, "years")
  ).trigger('input');
}
/* End set history data to input fields  */

const calHistory = new CalculatorHistory();

$("#calculate").on("click", function () {
  $(".last-three-calculations").show();
  calHistory.saveCalculatorHistory({
    totalReturns: calculatefutureReturn(),
    estReturns: calculatefutureReturn() - totalInvestment,
    investment: totalInvestment,
    periods: timePeriod,
    interest: returnRate,
    time: numberofyear,
  });

  let reopenIcon = document.location.origin + '/app/themes/upstox/dist/img/mutual-funds-return/view-more-icon.svg';

  calHistory.displayCalculatorHistory((data, index) => {
    return `<div class="expected-col" ><div class="common-col history-data">
    <h6>Invested: <span class="invest-amount-history">${getOuputFormat(data.investment)}</span></h6>
    <h6>Expected Return: <span class="return-history">${getOuputFormat(data.interest,'percent')}</span></h6>
    <h6>Time Period: <span class="time-history">${getOuputFormat(data.time, 'years')}</span> </h6>
</div>  <a href="#future-value-calculator" class="mobile-last-calc history-cal" data-id="${index}">Re-open <img src="${reopenIcon}"></a></div>`
  });

});

$(document).ready(function() {
  $(document).on("click", ".history-cal", function () {
    initializeSlider();
    const key = $(this).data("id");
    setHistoryValuesToInputFields(calHistory.history, key);
  });
});